<template>
    <div class="contentbox setaddress">
      <div class="setaddressbox2">
        <ul>
          <li :key="itme.group_id" v-for="(itme) in addresslist">
            <div>
              <div>{{itme.group_name}}</div>
              <p>$ {{itme.group_company_offer}}</p>
              <p @click="onshowchild(itme.group_id)">
                <Dot :state="itme.state" :bacolor="true">
                  <!--<slot>√</slot>-->
                </Dot>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
  import { MessageBox,Radio,Toast,Button  } from 'mint-ui';
  import Dot from '../Dot/Dot'
  import {getDeliveryAddressGroup} from '../../assets/js/api'
    export default {
        name: "Setregion",
        data(){
          return{
            addresslist:[],
            childaddresslist:[],
            value:'',
            time_type:this.$store.state.time_type,
            options:[],
            Firstleveladdress:'',
            info:[],
          }
        },
        components:{
          Radio,
          MessageBox,
          Toast,
          Button,
          Dot
        },
        mounted(){
          getDeliveryAddressGroup(this.time_type).then((data)=>{
            data.info = data.info || []
            data.info.map((itme)=>{
              itme.state = false
              // 回写运输费id
              this.$store.state.freight.map(list=>{
                if (list === itme.group_id) {
                  itme.state = true
                }
              })
            })
            this.addresslist = data.info
          })
        },
        methods:{
          onshowchild(id){
            let a = 0
            let freight = []
            this.addresslist.map((itme)=>{
              this.$store.state.shippingcost += itme.group_company_offer
              if (itme.group_id === id) {
                itme.state = !itme.state
              }
              if (itme.state){
                a += Number.parseFloat(itme.group_company_offer)
                freight.push(itme.group_id)
              }
            })
            this.$store.commit('set_freight',freight)
            this.$store.commit('set_shippingcost',a)
            this.$emit('computed_alltotal')
          },
        },
        computed:{
        }
    }
</script>

<style lang="less">
  @import "../../assets/less/base";
  #app{
    .contentbox.setaddress{
      background-color: #fff;
      width: 100%;
      .toptitle{
        position: fixed;
        z-index: 2008;
        background-color: @maincolor;
        height: 52px;
        font-size: 16px;
        line-height: 52px;
        color: #fff;
        box-shadow: 0px 2px 5px 2px #e8e8e8;
        text-align: center;
        display: flex;
        justify-content: space-between;
        width: 90%;
        padding: 0 5%;
        .return{
          font-size: 40px;
          cursor: pointer;
        }
        .topimgbox{
          cursor: pointer;
        }
      }
      .setaddressbox2{
        width: 100%;
        background: #fff;
        cursor: initial;
        ul{
          padding: 10px;
          li{
            height: auto;
            >div{
              display: flex;
              justify-content: space-between;
              justify-items: center;
              padding: 10px;
              div{
                display: flex;
                justify-content: space-between;
                justify-items: center;
                p{
                  width: 30%;
                  text-align: center;
                }
              }

            }
          }
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/assembly/Setregion/Setregion.vue